import { attr, Model } from 'redux-orm';
import {
  createAddConst,
  createAction,
  createLoadConst,
  createDeleteConst,
  createRequestConst,
  createUpdateConst,
  dateAndTime,
} from '../util';

export default class PublicKeys extends Model {
  static get modelName() {
    return 'PublicKeys';
  }

  static reducer({ type, data }, PublicKeys) {
    switch (type) {
      case ADD.SUCCESS:
        PublicKeys.upsert(data);
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      clientId: attr(),
      keyValue: attr(),
      status: attr(),
    };
  }
}

const name = PublicKeys.modelName;

export const ADD = createAddConst(name);

export const add = createAction(ADD);
